<template>
    <List
        :items="items"
        @dispensar="$emit('dispensar', $event)"
        :totalMedicamentosPendentes="totalMedicamentosPendentes"
    />
</template>

<script>
// Components
import List from '../components/medicamento-pendente/List'

export default {
    components: { List },
    props: {
        items: { type: Array, default: () => [] },
        totalMedicamentosPendentes: { type: Number, default: 0 },
    },
}
</script>